export default {
    cls: {
        execute(param, gameState, gameController) {
            gameController.clearHistory();
            return [{
                lines: [],
                startAt: 0,
                mute: true
            }];
        }
    }
}